import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography } from '@mui/material';
import useSettings from '../../../../hooks/useSettings';
import Page from '../../../../components/Page';
import { useSelector } from 'react-redux';
import DataGridTable from '../../../../components/table/DataGridTable';
import { capitalize, utcMoment } from '../../../../utils/common';
import { dispatch } from '../../../../redux/store';
import { getMySpaceTimeLog } from '../../../../redux/slices/homeRedux/mySpaceRedux';

export default function MySpace() {
  const { themeStretch } = useSettings();
  const [timeLog, setTimeLog] = useState([]);

  let rawTimeLog;
  ({ data: rawTimeLog } = useSelector((state) => state.myspace));

  useEffect(() => {
    dispatch(getMySpaceTimeLog());
  }, []);

  useEffect(() => {
    setTimeLog(
      rawTimeLog?.map((value) => {
        return {
          date: utcMoment(value?.datetime).format('YYYY-MM-DD'),
          time: utcMoment(value?.datetime).format('HH:mm:ss'),
          ...value,
        };
      })
    );
  }, [rawTimeLog]);

  const columns = timeLog?.[0]
    ? Object.keys(timeLog?.[0])
        .map((value) => {
          if (['userId', 'datetime', 'id', 'locationId'].includes(value)) {
            return null;
          } else {
            return {
              accessorKey: value,
              header: capitalize(value),
            };
          }
        })
        .filter(Boolean)
    : [];

  return (
    <Page title='My Space '>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={6}>
            <Typography variant='h6' sx={{ color: 'text.secondary' }}>
              Time Log
            </Typography>
            <DataGridTable
              name={'Time Log'}
              data={timeLog}
              column={columns}
              onRowClick={(row) => {}}
              isRowClickable={false}
              isLoading={false}
              setRowSelection={() => {}}
              enableRowSelection={false}
              enableRowActions={false}
              renderRowActionItems={(value, closeMenu) => []}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
